import React from 'react';
import { useMutation } from '@apollo/client';
import TrackerFeedbackMutation from './TrackerFeedbackMutation';

interface ITrackerFeedbackConnectorApolloProps {
  children: ({ requestFeedback }: { requestFeedback: any }) => React.ReactElement;
}

const TrackerFeedbackConnectorApollo: React.FC<ITrackerFeedbackConnectorApolloProps> = ({
  children,
}) => {
  const [feedbackMutation] = useMutation(TrackerFeedbackMutation);

  const requestFeedback = async (requestId: string, feedback: boolean) => {
    const response = await feedbackMutation({
      variables: { requestId, feedback },
    });

    return response.data.dailyTracker.aiRequestFeedback;
  };
  return children({ requestFeedback });
};

export default TrackerFeedbackConnectorApollo;
